import Input from './TextArea';

export default Input;
